import { createIntl, createIntlCache } from "react-intl";

import messages from "@/modules/workflow/i18n/en-US.json";

// This is optional but highly recommended since it prevents memory leak
const cache = createIntlCache();
export const workflowIntl = createIntl({ locale: "en-US", defaultLocale: "en-US", messages }, cache);
